import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from 'reactstrap';

import { Button } from "primereact/button";
// config file

const UniqueCases = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [rolesList, setRolesList] = useState([]);
  const [gotRoles, setgotRoles] = useState(false);
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  const params = useParams();
  useEffect(() => {
    getRoleListFromServer();
    let screenPermissions = RolePermissions.screenPermissions("Users");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };
  const getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest("GET", url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = [];
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }
          setRolesList(rolesList);
          setgotRoles(true);
        }
      })
      .catch((err) => {
        setgotRoles(true);
        return err;
      });
  };


  const getTableFields = () => {

    const caseTypeOptions = [
      { label: "All", value: null, color: "secondary" },
      { label: "contract", value: "contract", color: "danger" },
      { label: "dispute", value: "dispute", color: "warning" },
      { label: "regulatory", value: "regulatory", color: "info" },
      { label: "financial", value: "financial", color: "success" },
      { label: "litigation", value: "litigation", color: "primary" },
      { label: "Civil", value: "Civil", color: "info" },
      { label: "REAL_ESTATE", value: "REAL_ESTATE", color: "secondary" },
      { label: "LEGAL_CRIMINAL", value: "LEGAL_CRIMINAL", color: "danger" },
      { label: "LEGAL_DISPUTE", value: "LEGAL_DISPUTE", color: "warning" },
      { label: "LEGAL_REGULATORY", value: "LEGAL_REGULATORY", color: "info" },
      { label: "LEGAL_FINANCIAL", value: "LEGAL_FINANCIAL", color: "success" },
      { label: "LEGAL_LITIGATION", value: "LEGAL_LITIGATION", color: "primary" },
      { label: "LEGAL_REAL_ESTATE", value: "LEGAL_REAL_ESTATE", color: "secondary" },
    ];

    const categoryOptions = [
      { label: "All", value: null, color: "secondary" },
      { label: "contract", value: "contract", color: "danger" },
      { label: "dispute", value: "dispute", color: "warning" },
      { label: "regulatory", value: "regulatory", color: "info" },
      { label: "financial", value: "financial", color: "success" },
      { label: "litigation", value: "litigation", color: "primary" },
      { label: "Civil", value: "Civil", color: "info" },
      { label: "Constitutional", value: "Constitutional", color: "success" },
      { label: "REAL_ESTATE", value: "REAL_ESTATE", color: "secondary" },
      { label: "Criminal", value: "Criminal", color: "danger" },
      { label: "Dispute", value: "Dispute", color: "warning" },
      { label: "Regulatory", value: "Regulatory", color: "info" },
      { label: "Financial", value: "Financial", color: "success" },
      { label: "Litigation", value: "Litigation", color: "primary" },
      { label: "Real Estate", value: "Real Estate", color: "secondary" },
    ];

    const resultOptions = [
      { label: "All", value: null, color: "secondary" },
      { label: "STRONG", value: "STRONG", color: "success" },
      { label: "WIN", value: "WIN", color: "primary" },
      { label: "FAIL", value: "FAIL", color: "danger" },
      { label: "MODERATE", value: "MODERATE", color: "primary" },
    ];

    const strengthOptions = [
      { label: "All", value: null, color: "secondary" },
      { label: "STRONG", value: "STRONG", color: "success" },
      { label: "WEAK", value: "WEAK", color: "danger" },
    ];

    let data = [
      // Checkbox column
      {
        textAlign: "center",
        width: "40px",
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      // Serial number column
      {
        textAlign: "center",
        width: "40px",
        field: "Sno",
        label: "SNo",
        header: "SNo",
        sortable: false,
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "fileName",
        fieldName: "fileName",
        type: "text",
        placeholder: "Name",
        value: "",
        label: "Name",
        width: "40",
        addFormOrder: 10,
        editFormOrder: 10,
        stringType: null,
        header: "Name",
        derivedValue: "fileName=undefined",
        capitalizeTableText: false,
        sortable: true,
        filter: true,
        id: "fileName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: "",
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        isBulkUploadField: true,
        textAlign: "left",
        show: true,
        field: "fileName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        tDisplay: true,
      },
      {
        name: "category",
        type: "dropDown",
        placeholder: "category",
        label: "category",
        header: "category",
        field: "category",
        options: categoryOptions,
        width: "150px",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        isFieldRequired: "true",
        style: { textTransform: "uppercase" },
      },
      {
        name: "subCategory",
        type: "dropDown",
        placeholder: "subCategory",
        label: "subCategory",
        header: "subCategory",
        field: "subCategory",
        options: caseTypeOptions,
        isMultiSelect: true,
        width: "150px",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        isFieldRequired: "true",
        style: { textTransform: "uppercase" },
      },
      // {
      //   name: "caseType",
      //   type: "dropDown",
      //   placeholder: "Case Type",
      //   label: "Case Type",
      //   header: "Case Type",
      //   field: "caseType",
      //   options: caseTypeOptions,
      //   width: "150px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   isFieldRequired: "true",
      //   style: { textTransform: "uppercase" },
      // },
      // {
      //   name: "created",
      //   type: "date",
      //   placeholder: "Created",
      //   label: "Created",
      //   header: "Created",
      //   width: "120px",
      //   id: "created",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   controllerName: null,
      //   fieldType: "Date",
      //   dateFormat: "MM/DD/YYYY", // or use config.dateFormat
      //   textAlign: "center",
      //   disabled: false,
      //   show: true,
      //   field: "created",
      //   isFieldRequired: "false",
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      // },
      // Actions column
      // {
      //   show: true,
      //   textAlign: "center",
      //   width: "100px",
      //   fieldType: "Actions",
      //   field: "Actions",
      //   header: "Actions",
      //   label: "Actions",
      //   filter: false,
      //   sortable: false,
      //   displayInSettings: true,
      //   displayinlist: "true",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   globalSearchField: "false",
      //   isFieldRequired: "false",
      //   mobile: true,
      //   tDisplay: true,
      // },
    ];

    return data;
  };

  const getFormFields = () => {
    // Define option lists for dropdowns (could be fetched from API or constants)
    const caseTypeOptions = [
      { label: "LEGAL_CRIMINAL", value: "LEGAL_CRIMINAL" },
      { label: "LEGAL_DISPUTE", value: "LEGAL_DISPUTE" },
      { label: "LEGAL_REGULATORY", value: "LEGAL_REGULATORY" },
      { label: "LEGAL_FINANCIAL", value: "LEGAL_FINANCIAL" },
      { label: "LEGAL_LITIGATION", value: "LEGAL_LITIGATION" },
      { label: "LEGAL_REAL_ESTATE", value: "LEGAL_REAL_ESTATE" },
    ];

    const resultOptions = [
      { label: "STRONG", value: "STRONG" },
      { label: "WIN", value: "WIN" },
      { label: "FAIL", value: "FAIL" },
      { label: "MODERATE", value: "MODERATE" }
    ];

    const strengthOptions = [
      { label: "STRONG", value: "STRONG" },
      { label: "WEAK", value: "WEAK" },
      { label: "MODERATE", value: "MODERATE" }

    ];

    return [
      // File Name
      {
        name: "fileName",
        type: "text",
        placeholder: "Enter file name",
        label: "File Name",
        width: "100", // percentage or pixel? adjust as needed
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "fileName=undefined",
        sortable: false,
        filter: false,
        id: "fileName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: "false",
        displayinlist: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        isEditFieldDisable: false,
        showOrHideFields: [],
        isFieldRequired: "true",
        mobile: true,
        displayInSettings: true,
        fieldType: "text",
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      // Case Type
      {
        name: "caseType",
        type: "dropDown",
        placeholder: "Select case type",
        label: "Case Type",
        derivedValue: "caseType=undefined",
        actions: [],
        width: "100",
        actionsNumber: [],
        id: "caseType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: caseTypeOptions,
        show: true,
        disabled: false,
        mobile: true,
        globalSearchField: "true",
        isFieldRequired: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 2,
        editFormOrder: 2,
        defField: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      // Result
      {
        name: "result",
        type: "dropDown",
        placeholder: "Select result",
        label: "Result",
        derivedValue: "result=undefined",
        actions: [],
        width: "100",
        actionsNumber: [],
        id: "result",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: resultOptions,
        show: true,
        disabled: false,
        mobile: true,
        globalSearchField: "true",
        isFieldRequired: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 3,
        editFormOrder: 3,
        defField: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      // Win Probability (nested, but form will handle as separate field)
      {
        name: "winProbability",
        type: "number",
        placeholder: "0.00 - 1.00",
        label: "Win Probability",
        id: "winProbability",
        width: 100,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isEditFieldDisable: false,
        controllerName: null,
        displayinregisterForm: "false",
        disabled: false,
        show: true,
        globalSearchField: "false",
        required: false,
        isFieldRequired: "false",
        addFormOrder: 4,
        editFormOrder: 4,
        defField: true,
        fieldName: "winProbability",
        fieldType: "number",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        step: 0.01,
        min: 0,
        max: 1,
      },
      // Strength
      {
        name: "strength",
        type: "dropDown",
        placeholder: "Select strength",
        label: "Strength",
        derivedValue: "strength=undefined",
        actions: [],
        width: 100,
        actionsNumber: [],
        id: "strength",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: strengthOptions,
        show: true,
        disabled: false,
        mobile: true,
        globalSearchField: "true",
        isFieldRequired: "false",
        required: false,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 5,
        editFormOrder: 5,
        defField: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "keyPoints",
        type: "textarea", // or a custom "tag" type
        placeholder: "Enter key points (one per line)",
        label: "Key Points",
        id: "keyPoints",
        width: 180,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        show: true,
        disabled: false,
        globalSearchField: "true",
        addFormOrder: 7,
        editFormOrder: 7,
        defField: true,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        // You may want to convert array to string for display and back
      },
      // Created (read-only, auto-generated)
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "MM/dd/yyyy", // or config.dateFormat
        disabled: true, // read-only
        show: false, // hidden by default, but can be shown
        addFormOrder: 8,
        editFormOrder: 8,
        defField: true,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,  // hide in add form
        isEditFormHidden: false, // show in edit form as read-only
      },
      // _id (hidden, for updates)
      {
        name: "_id",
        type: "hidden",
        placeholder: "",
        label: "",
        id: "_id",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "false",
        show: false,
        addFormOrder: 99,
        editFormOrder: 99,
        isAddFormHidden: true,
        isEditFormHidden: false,
        fieldType: "hidden",
      },
    ];
  };
  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
    console.log("Submit Button in sode          ");
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "firstName",
        type: "text",
        placeholder: "First Name",
        label: "First Name",
        width: "50",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "First Name",
        derivedValue: "firstName=undefined",
        sortable: false,
        filter: true,
        id: "firstName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: "true",
        displayinlist: "true",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "firstName",
        showOrHideFields: [],
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        tDisplay: true,
      },
      {
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
        label: "Last Name",
        width: "130px",
        addFormOrder: 2,
        editFormOrder: 2,
        header: "Last Name",
        derivedValue: "lastName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: true,
        actions: [],
        actionsNumber: [],
        id: "lastName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "lastName",
        showOrHideFields: [],
        fieldName: "lastName",
        fieldType: "text",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email",
        label: "Email",
        id: "email",
        width: 150,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        disabled: false,
        show: true,
        globalSearchField: "true",
        required: true,
        isFieldRequired: "true",
        field: "email",
        header: "Email",
        addFormOrder: 3,
        editFormOrder: 2,
        defField: true,
        fieldName: "email",
        fieldType: "email",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "role",
        type: "dropDown",
        placeholder: "Role",
        label: "Role",
        header: "Role",
        derivedValue: "role=undefined",
        actions: [],
        width: 50,
        actionsNumber: [],
        id: "role",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: [],
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "role",
        mobile: true,
        globalSearchField: "true",
        isFieldRequired: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 4,
        editFormOrder: 4,
        defField: true,
        tDisplay: true,
      },
      {
        name: "phone",
        type: "text",
        placeholder: "Phone",
        label: "Phone",
        id: "phone",
        width: 50,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        show: true,
        disabled: false,
        field: "phone",
        header: "Phone",
        addFormOrder: 5,
        editFormOrder: 3,
        defField: true,
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "reportingTo",
        type: "relateAutoComplete",
        placeholder: "ReportingTo",
        label: "ReportingTo",
        header: "ReportingTo",
        derivedValue: "reportingTo=undefined",
        actions: [],
        actionsNumber: [],
        id: "reportingTo",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: "employee",
        searchField: "name",
        fieldType: "relateAutoComplete",
        controllerId: 1001,
        searchApi: "employees",
        width: 110,
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "reportingTo",
        addFormOrder: 6,
        editFormOrder: 5,
        defField: true,
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "address",
        type: "textarea",
        placeholder: "Address",
        label: "Address",
        id: "address",
        width: 180,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        show: true,
        disabled: false,
        globalSearchField: "true",
        field: "address",
        header: "Address",
        addFormOrder: 7,
        editFormOrder: 6,
        defField: true,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "password",
        type: "password",
        placeholder: "password",
        label: "password",
        id: "password",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        show: true,
        displayInSettings: false,
        disabled: false,
        isFieldRequired: "true",
        required: true,
        field: "password",
        header: "password",
        addFormOrder: 8,
        editFormOrder: 7,
        defField: true,
        fieldName: "password",
        fieldType: "password",
        globalSearchField: "false",
        mobile: true,
        tDisplay: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: config.dateFormat,
        textAlign: "Center",
        disabled: false,
        show: true,
        field: "created",
        addFormOrder: 10,
        editFormOrder: 10,
        defField: true,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: config.dateFormat,
        textAlign: "Center",
        disabled: false,
        show: true,
        field: "updated",
        addFormOrder: 11,
        editFormOrder: 11,
        defField: true,
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();
  };
  const getChangedRoleOptions = () => {
    let fields = getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = rolesList && rolesList.length > 0 ? rolesList : [];
        }
      }
    }
    return fields;
  };
  const saveDataToServer = async (item, field, value) => {
    let userBody;
    if (item?.length > 0 && field && value) {
      let selectedIds = item.map((row) => row._id);
      userBody = {
        selectedIds: selectedIds,
        updatedDetails: { [field]: value },
      };
    } else {
      return;
    }
    if (userBody) {
      let method, apiUrl;
      method = "POST";
      apiUrl = `${apiCalls.employees}/multiUpdate`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  const uniqueCaseDisplay = (data) => {
    if (!data) return null;

    // Styling (same as original)
    const lightGradient = 'linear-gradient(145deg, #f9fcff 0%, #e9f0f9 100%)';
    const cardBg = '#ffffff';
    const cardShadow = '0 8px 20px -8px rgba(0, 32, 64, 0.08)';
    const borderLight = '1px solid rgba(0, 0, 0, 0.05)';
    const textPrimary = '#1a2b3c';
    const textSecondary = '#4a5b6b';
    const accentBlue = '#011f5eff';

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    const filePath = data?.path || null;
    const fileUrl = filePath ? `${config.imgUrl}${filePath}` : null;

    const sectionCardStyle = {
      background: cardBg,
      boxShadow: cardShadow,
      border: borderLight,
      borderRadius: '16px',
      padding: '1rem 1.2rem',
      marginBottom: '1rem',
    };

    const metadataRowStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      marginBottom: '0.5rem',
      fontSize: '0.9rem',
    };

    // Helper to parse liability percentages from judgement summary
    const parseLiabilityPercentages = (summary) => {
      if (!summary) return null;
      // Example: "Liability divided: 70% defendant, 30% plaintiff."
      const match = summary.match(/(\d+)%\s*defendant.*?(\d+)%\s*plaintiff/i);
      if (match) {
        return {
          defendant: parseInt(match[1]),
          plaintiff: parseInt(match[2]),
        };
      }
      // Try alternative order
      const altMatch = summary.match(/(\d+)%\s*plaintiff.*?(\d+)%\s*defendant/i);
      if (altMatch) {
        return {
          plaintiff: parseInt(altMatch[1]),
          defendant: parseInt(altMatch[2]),
        };
      }
      return null;
    };

    // Simple SVG Pie Chart component
    const PieChart = ({ data, colors = ['#00238cff', '#72008cff'] }) => {
      const total = data.defendant + data.plaintiff;
      if (total === 0) return null;

      const radius = 50;
      const center = 60; // 60x60 viewBox
      const startAngle = -90; // start at top (12 o'clock)

      const toRadians = (deg) => (deg * Math.PI) / 180;

      const getArcPath = (startDeg, endDeg) => {
        const start = toRadians(startDeg);
        const end = toRadians(endDeg);
        const x1 = center + radius * Math.cos(start);
        const y1 = center + radius * Math.sin(start);
        const x2 = center + radius * Math.cos(end);
        const y2 = center + radius * Math.sin(end);
        const largeArcFlag = endDeg - startDeg <= 180 ? 0 : 1;
        return `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
      };

      const defendantAngle = (data.defendant / total) * 360;
      const plaintiffAngle = (data.plaintiff / total) * 360;

      const defendantEnd = startAngle + defendantAngle;
      const plaintiffStart = defendantEnd;
      const plaintiffEnd = plaintiffStart + plaintiffAngle;

      return (
        <svg viewBox="0 0 120 120" width="120" height="120">
          <g transform="rotate(0 60 60)">
            <path d={getArcPath(startAngle, defendantEnd)} fill={colors[0]} stroke="white" strokeWidth="1" />
            <path d={getArcPath(plaintiffStart, plaintiffEnd)} fill={colors[1]} stroke="white" strokeWidth="1" />
          </g>
        </svg>
      );
    };

    // Extract percentages if present
    const liabilityPerc = parseLiabilityPercentages(data.judgementSummary);

    return (
      <div
        style={{
          background: lightGradient,
          color: textPrimary,
          borderRadius: '24px',
          boxShadow: '0 12px 30px -12px rgba(0, 20, 40, 0.2)',
          padding: '1.5rem',
        }}
      >
        {/* ===== HEADER ===== */}
        <div
          className="d-flex align-items-center justify-content-between mb-4 pb-2"
          style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                background: 'rgba(37, 99, 235, 0.1)',
                borderRadius: '14px',
                padding: '0.6rem',
                marginRight: '1rem',
              }}
            >
              <FontAwesomeIcon icon="file-alt" style={{ color: accentBlue, fontSize: '1.3rem' }} />
            </div>
            <div>
              <h5 className="mb-0 fw-medium" style={{ color: accentBlue }}>
                <a
                  href={fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: accentBlue, textDecoration: 'none', fontWeight: 500, wordBreak: 'break-all' }}
                >
                  {data.fileName || data.caseId?.fileName || 'Untitled'}
                </a>
              </h5>

              <div className="d-flex flex-wrap gap-2 mt-1">
                <span
                  style={{
                    background: 'rgba(0, 0, 0, 0.04)',
                    color: textSecondary,
                    borderRadius: '30px',
                    padding: '0.25rem 1rem',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  }}
                >
                  {data.category || 'N/A'}
                </span>
                {data.subCategory && (
                  <span
                    style={{
                      background: 'rgba(0, 0, 0, 0.04)',
                      color: textSecondary,
                      borderRadius: '30px',
                      padding: '0.25rem 1rem',
                      fontSize: '0.75rem',
                      fontWeight: '500',
                    }}
                  >
                    {data.subCategory}
                  </span>
                )}
                <span
                  style={{
                    background: 'rgba(0, 0, 0, 0.04)',
                    color: textSecondary,
                    borderRadius: '30px',
                    padding: '0.25rem 1rem',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  }}
                >
                  <FontAwesomeIcon icon="calendar" size="xs" style={{ marginRight: '0.3rem' }} />
                  {formatDate(data.insertedAt)}
                </span>
              </div>
            </div>
          </div>
          {fileUrl && (
            <div>
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: accentBlue, textDecoration: 'none', fontWeight: 500 }}
              >
                View File <FontAwesomeIcon icon="file-export" />
              </a>
            </div>
          )}
        </div>

        {/* Tags */}
        {data.tags && data.tags.length > 0 && (
          <div style={sectionCardStyle}>
            <h6 className="d-flex align-items-center gap-2 mb-2 fw-medium" style={{ color: accentBlue, fontWeight: 600, fontSize: "16px" }}>
              <FontAwesomeIcon icon="tags" style={{ color: accentBlue }} size="sm" /> Tags
            </h6>
            <div className="d-flex flex-wrap gap-1">
              {data.tags.map((tag, idx) => (
                <Badge key={idx} color="secondary" style={{ fontSize: '10px' }}>
                  {tag}
                </Badge>
              ))}
            </div>
          </div>
        )}

        {/* ===== TWO-COLUMN LAYOUT ===== */}
        <div className="row g-4">
          {/* LEFT COLUMN */}
          <div className="col-lg-5">

            {/* Unique Factors */}
            {data.uniqueFactors && data.uniqueFactors.length > 0 && (
              <div style={sectionCardStyle}>
                <h6 className="d-flex align-items-center gap-2 mb-2 fw-medium" style={{ color: accentBlue, fontWeight: 600, fontSize: "16px" }}>
                  <FontAwesomeIcon icon="star" style={{ color: accentBlue }} size="sm" /> Unique Factors
                </h6>
                <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                  {data.uniqueFactors.map((factor, idx) => (
                    <li key={idx} style={{ color: textSecondary, marginBottom: '0.4rem', fontSize: '0.85rem' }}>
                      {factor}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Comparison Reason */}
            {data.comparisonReason && (
              <div style={sectionCardStyle}>
                <h6 className="d-flex align-items-center gap-2 mb-2 fw-medium" style={{ color: accentBlue, fontWeight: 600, fontSize: "16px" }}>
                  <FontAwesomeIcon icon="info-circle" style={{ color: accentBlue }} size="sm" /> Comparison Reason
                </h6>
                <p style={{ color: textSecondary, fontSize: '0.85rem', marginBottom: 0 }}>
                  {data.comparisonReason}
                </p>
              </div>
            )}

            {/* Status & Processing */}
            <div style={sectionCardStyle}>
              <h6 className="d-flex align-items-center gap-2 mb-2 fw-medium" style={{ color: accentBlue, fontWeight: 600, fontSize: "16px" }}>
                <FontAwesomeIcon icon="cog" style={{ color: accentBlue }} size="sm" /> Status & Processing
              </h6>
              <div style={metadataRowStyle}>
                <FontAwesomeIcon icon="check-double" style={{ color: textSecondary, width: '1.2rem' }} />
                <span style={{ color: textSecondary, flex: 1 }}>Completed:</span>
                <Badge color={data.caseId.isCompleted ? 'success' : 'warning'} style={{ fontSize: '10px' }}>
                  {data.caseId.isCompleted ? 'Yes' : 'No'}
                </Badge>
              </div>
              <div style={metadataRowStyle}>
                <FontAwesomeIcon icon="star" style={{ color: textSecondary, width: '1.2rem' }} />
                <span style={{ color: textSecondary, flex: 1 }}>Unique Case:</span>
                <Badge color={data.caseId.isUniqueCase ? 'success' : 'secondary'} style={{ fontSize: '10px' }}>
                  {data.caseId.isUniqueCase ? 'Yes' : 'No'}
                </Badge>
              </div>
              <div style={metadataRowStyle}>
                <FontAwesomeIcon icon="balance-scale" style={{ color: textSecondary, width: '1.2rem' }} />
                <span style={{ color: textSecondary, flex: 1 }}>Comparison Result:</span>
                <Badge color={data.caseId.comparisonResult === 'unique' ? 'success' : 'secondary'} style={{ fontSize: '10px' }}>
                  {data.caseId.comparisonResult || 'N/A'}
                </Badge>
              </div>
              {data.caseId?.extractionStatus && (
                <div style={metadataRowStyle}>
                  <FontAwesomeIcon icon="cogs" style={{ color: textSecondary, width: '1.2rem' }} />
                  <span style={{ color: textSecondary, flex: 1 }}>Extraction Status:</span>
                  <span style={{ color: textPrimary, fontWeight: 500 }}>{data.caseId.extractionStatus}</span>
                </div>
              )}
              <div style={metadataRowStyle}>
                <FontAwesomeIcon icon="copy" style={{ color: textSecondary, width: '1.2rem' }} />
                <span style={{ color: textSecondary, flex: 1 }}>Similar Cases Compared:</span>
                <span style={{ color: textPrimary, fontWeight: 500 }}>{data.caseId.similarCasesCompared?.length || 0}</span>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="col-lg-7">
            {/* Judgement Summary with Pie Chart */}
            {data.judgementSummary && (
              <div style={sectionCardStyle}>
                <h6 className="d-flex align-items-center gap-2 mb-2 fw-medium" style={{ color: accentBlue, fontWeight: 600, fontSize: "16px" }}>
                  <FontAwesomeIcon icon="gavel" style={{ color: accentBlue }} size="sm" /> Judgement Summary
                </h6>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  {/* Pie Chart (if percentages available) */}
                  {liabilityPerc && (
                    <div className="text-center">
                      <PieChart data={liabilityPerc} />
                      <div className="mt-2 d-flex justify-content-center gap-3">
                        <div>
                          <span style={{ background: '#110092ff', display: 'inline-block', width: '12px', height: '12px', borderRadius: '2px', marginRight: '4px' }}></span>
                          <span style={{ fontSize: '0.75rem' }}>Defendant {liabilityPerc.defendant}%</span>
                        </div>
                        <div>
                          <span style={{ background: '#72008cff', display: 'inline-block', width: '12px', height: '12px', borderRadius: '2px', marginRight: '4px' }}></span>
                          <span style={{ fontSize: '0.75rem' }}>Plaintiff {liabilityPerc.plaintiff}%</span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div style={{ flex: 1, minWidth: '200px' }}>
                    <p style={{ color: textSecondary, fontSize: '0.9rem', marginBottom: 0, whiteSpace: 'pre-wrap' }}>
                      {data.judgementSummary}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Legal Strategy */}
            {data.legalStrategy && (
              <div style={sectionCardStyle}>
                <h6 className="d-flex align-items-center gap-2 mb-2 fw-medium" style={{ color: accentBlue, fontWeight: 600, fontSize: "16px" }}>
                  <FontAwesomeIcon icon="balance-scale" style={{ color: accentBlue }} size="sm" /> Legal Strategy
                </h6>
                <p style={{ color: textSecondary, fontSize: '0.9rem', marginBottom: 0, whiteSpace: 'pre-wrap' }}>
                  {data.legalStrategy}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };


  return (
    <span>
      {gotRoles && (
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getChangedRoleOptions}
          //
          addRequired={
            false
          }
          editRequired={
            false
          }
          deleteRequired={
            false
          }
          viewRequired={
            true
          }
          exportRequired={
            true
          }
          sample={true}
          actionsTypes={[
            {
              name: "Delete",
              options: [
                {
                  label: "Delete",
                  value: "Delete",
                  show:
                    rolePermission && rolePermission == "Edit" ? true : false,
                  multiple: true,
                },
              ],
            },
          ]}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          exportToCsv={true}
          dateSearchRequired={undefined}
          searchInDateRangeField={"undefined"}
          sampleFilePath={filePath.employees}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          globalSearch={
            "First Name / Last Name / Email / Role "
          }
          displayName="UniqueCases"
          type="uniqueCases"
          routeTo={apiCalls.uniqueCases}
          sideFormLeftOrRight=""
          displayViewOfForm="modal"
          apiResponseKey={apiCalls.uniqueCases?.toLowerCase()}
          apiUrl={apiCalls.uniqueCases}
          selectedId={params.id}
          buttonToolTips={{ add: 'Add User' }}
          softUpdate={true}
          softDelete={true}
          actionOverlayPanel={false}
          customViewModal={uniqueCaseDisplay}
        />
      )}
      {isOpenFormModal ? (
        <FormModal
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="employees"
          apiUrl={apiCalls.employees}
        />
      ) : null}
    </span>
  );
};

export default UniqueCases;
